import { Component, OnInit } from '@angular/core';
import { ApplicationService } from 'app/services/application.service';
import { StatusService } from 'app/services/status.service';
import { AuthWebService } from 'app/services/authweb.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { CompliancereturnsService } from 'app/services/compliancereturns.service';
import { CalendarService } from '../../services/calendar.service';
import { environment } from '../../../environments/environment';



@Component({
  selector: 'app-compliance-application',
  templateUrl: './compliance-application.component.html',
  styleUrls: ['./compliance-application.component.css']
})
export class ComplianceApplicationComponent implements OnInit {

  pageSize: number = 10;
  count: number = 0;
  processHeader = null;
  isEmpty: boolean = false;
  carrierpermitlist: any;
  carrierid: number;
  calendarid: number =0;
  calendarList: any = [];
  lastSixMonths: any = [];
  carrierNameNew: string = "";
  viewPage: boolean = false;
  permitCode: string = "";
  permitNumber: string = "";
  permit : any;
 showPage: boolean;
 view: number = 0;
 dataCntrl: any = {complianceID: -1, carrierID: -1,appID: -1,compID:-1 ,permittypeSelected: false, selectedtype: '', disableTypes: false, processStarted: false, currentTab: '', formValid: false, isViewEditControl: false, carrier: {}, application: {}, permit: {}, permittype: {}, vehicles: [], permitTypesDocLinks: [] };
 viewAppId:any=null;
 viewPermitCount:any=null;
 Compliance_PermitType_Id:any = 0;
 isView :  boolean = false;
 
  constructor(private activateRouter:ActivatedRoute,private complianceService: CompliancereturnsService ,private route:Router, public applicationService: ApplicationService,public utility: UtilityServiceService,private router: Router, public complianceservice: CompliancereturnsService, public _calandarService: CalendarService, private activeRoute: ActivatedRoute) { }

  ngOnInit() {
this.activeRoute.queryParams.subscribe(params => {
  // Defaults to 0 if no query param provided.
  
  this.view = +params['view'] || 0;
  this.dataCntrl.carrierID = params['id'];
  this.dataCntrl.appID = params['appID'];
  this.dataCntrl.compID = params['compID'];
  this.isView = params['isView'];
  this.getApplicationDetails(this.dataCntrl.compID);
//alert(this.dataCntrl.compID);
  this.dataCntrl.application.id = params['appID'];
 
    // if (environment.authWebApi.userData.Roles.find(p => p.Code == 'ADMIN')) {
      
  this.complianceService.GetComplianceById(this.dataCntrl.compID ).subscribe((compliance: any)=>{

    this.permitNumber = compliance.permit_num;
      this.applicationService.getByIdForComplianceApp(this.dataCntrl.appID, this.permitNumber).subscribe((data: any) => {
        
        this.applicationService.dataControlTrackChanges = data;
        this.dataCntrl.application = data;
        this.carrierNameNew = data.carrier.name;
        this.permitCode = data.permit_type.Compliance_code;
       
        this.Compliance_PermitType_Id = data.permit_type.Compliance_PermitType_Id;
        console.log(data)
        localStorage.setItem('accNum', data.carrier.carrier_code);
        localStorage.setItem('addressTown', data.carrier.physical_address_town);
        localStorage.setItem('addressPostalCode', data.carrier.physical_post_code);
        
       // alert(JSON.stringify(data.permit[0]));
        //alert(JSON.stringify(data));

        
        if(localStorage.getItem("permitNum")!=undefined && localStorage.getItem("permitNum")!=null){
          let permitCount:any=parseInt(localStorage.getItem("permitNum"));
          this.viewPermitCount=permitCount;
        
          if(permitCount>1){
            this.viewAppId=params['id'];
          }else{
            if(data.permits.permit_num!=null && data.permits.permit_num>0){
              this.viewAppId=data.permits.permit_num;
            }else{
              this.viewAppId=params['id'];
            }
          }
          this.viewAppId= data.permits.permit_num;
      }
        // this.getSavedVehicleByPermit(this.dataCntrl.application.id);
        this.dataCntrl.carrierID = data.carrier_id;
        this.dataCntrl.permit_type_id = this.Compliance_PermitType_Id;
        this.dataCntrl.permits = [];
        this.dataCntrl.permits.push(data.permits.find(x=>x.id = compliance.permit_id));
        this.dataCntrl.permittype = data.permit_type;
        if (environment.authWebApi.userData.Roles.find(p => p.Code == 'ADMIN')) {

          //console.log('This is process Admin')
          this.dataCntrl.currentTab = 'permitype';
          // this.ctrlData.currentTab = 'permitype';
          //this.getCarrier();
          this.showPage = true;

        }
      });

    //}
  
  console.log(this.dataCntrl.application.id);

  this.dataCntrl.compID = params['compID'];
}); 
});
this.utility.activeTab = 0;

if (this.dataCntrl.complianceDetail != null ||  this.dataCntrl.complianceDetail != undefined) {
  this.utility.activeTab = 0;
  this.showPage = true;
  this.utility.confirmCtrl = true;
  
} else {
  
  this.showPage = true;
}
this.onActive();
    this._calandarService.getFirstMonths().subscribe(data => {
      this.calendarList = data;
      const dt = new Date();
      const thisMothCal = this.calendarList.find(x => dt.getMonth() + 1 == new Date(x.calendar_date).getMonth() + 1 && dt.getFullYear() == new Date(x.calendar_date).getFullYear());
      this.lastSixMonths = this.calendarList.slice(Math.max(this.calendarList.length - 6, 0));

      this.activeRoute.params.subscribe((params: Params) => {

        this.carrierid = params['carrierid'];
        this.calendarid = params['calendarid'];
      });
  
    });

 
  }
  getApplicationDetails(id)
  {
    this.complianceService.GetComplianceById(id).subscribe(data => {
        this.permitCode = data['code'];
    });
  }
  orderTabSequence = (isPlus, seq) => {
    return (isPlus) ? seq : seq;
  }
  onActive() {
    //this.iconCtrl = key;
    this.applicationService.getTab().subscribe(x => {
      //console.log(x);
      if (x >= 0) {
        this.utility.activeTab = x;
      }

    })
  }
  onActive1(tabNum) {
    
      this.applicationService.setTab(tabNum);
      this.onActive();


    
    if(tabNum==1){
      if(this.router.url.indexOf('edit')>0){
     
      }
    }
  
        this.applicationService.setTab(tabNum);
        this.utility.confirmCtrl = true;
        console.log(this.dataCntrl);
        this.onActive();

  } 
  onChange(): void {

  }
  onSearch(): void {

  }
  onReset(): void {

  }

}
